export default __webpack_public_path__ + "static/media/Group 148.995c46a4.png";